import fg from '#/libs/FrameGrid';
import { stringWithEllipsis } from '#/worker/toolkit';
// @NOTE: DO NOT TRY TO `import app from 'app';` - causes weird conflict

export function isAssetCandidateForTranscribe(asset) {
  const isSocialVideo =
    app.assetType.isSOCIALVIDEO(asset) || app.assetType.isSOCIALFRAGMENT(asset);
  const isVideo =
    app.assetType.isVIDEO(asset) ||
    app.assetType.isFRAGMENT(asset) ||
    isSocialVideo;
  const hasAudio = !!asset.hasValidAudio;
  const isUserSelfUpload = app.assetType.isInMyGallery(asset);
  const isEditorial = app.assetType.isEditorial(asset);

  return (
    isVideo && hasAudio && (isUserSelfUpload || isEditorial || isSocialVideo)
  );
}

/**
 * Check if token times fit into time span of audio segment
 *
 * @param token {{startTime: Number, endTime: Number}}
 * @param span {{startTime: Number, endTime: Number}}
 * @returns {boolean}
 */
export function isTokenRelevantInSpan(token, span) {
  let rv = false;

  const farOffLeft = token.endTime <= span.startTime;
  const farOffRight = token.startTime >= span.endTime;

  if (!(farOffLeft || farOffRight)) {
    const atRightEdge = token.endTime > span.endTime;
    const atLeftEdge = token.startTime < span.startTime;

    if (atLeftEdge || atRightEdge) {
      const inside = atRightEdge
        ? span.endTime - token.startTime
        : token.endTime - span.startTime;
      const outside = atRightEdge
        ? token.endTime - span.endTime
        : span.startTime - token.startTime;

      rv = atRightEdge ? inside >= outside : inside > outside;
    } else {
      rv = true;
    }
  }

  return rv;
}

export function getTrackSpanTranscriptionsTokens(
  tokens,
  trackTimes,
  rectangle
) {
  const span = {
    startTime: fg.trunc(
      rectangle.startTime - trackTimes.displayStartTime + trackTimes.startTime
    ),
    endTime: fg.trunc(
      rectangle.endTime - trackTimes.displayStartTime + trackTimes.startTime
    ),
  };

  const rv = [];
  for (let n = 0, N = tokens?.length, token; n < N; n++) {
    token = tokens[n];
    if ('WORD' === token.type && isTokenRelevantInSpan(token, span)) {
      rv.push(token);
    }
  }
  return rv;
}

export function drawSentencesInMainThread(canvas, scale, sentences) {
  const c = canvas.getContext('2d');
  canvas.width = scale.width;
  canvas.height = scale.height;
  drawSentencesOnContext(c, scale, sentences);
}

/**
 * @param c - canvas 2d context
 * @param scale {object}
 * @param sentences {array}
 */
export function drawSentencesOnContext(c, scale, sentences) {
  c.clearRect(0, 0, scale.width, scale.height);
  c.font = `${scale.fontSize}px Roboto`;
  c.textAlign = 'start';
  c.textBaseline = 'middle';
  c.fillStyle = scale.bgColour;
  c.fillRect(0, 0, scale.width, scale.height);
  c.fillStyle = scale.textColour;

  let n = sentences.length;
  const nLast = sentences.length - 1;
  while (n--) {
    const sentence = sentences[n];
    const padding = scale.isSentenceResolution
      ? n === nLast
        ? 0
        : scale.paddingRight
      : 0;

    const maxWidth = scale.factor * (sentence.width - padding);
    if (maxWidth > 0) {
      const { str, width } = stringWithEllipsis(c, sentence.text, maxWidth);
      let x = scale.factor * sentence.shift;
      const y = scale.factor + scale.height / 2;

      if (!scale.isSentenceResolution && width < maxWidth) {
        x += (maxWidth - width) / 2;
      }

      c.fillText(str, x, y);

      // auxiliary code that draws a diagonal line to outline token rectangle
      // c.moveTo(scale.factor * sentence.shift, 0);
      // c.lineTo(scale.factor * sentence.shift + maxWidth, scale.height);
      // c.stroke();
    }
  }
}
